<script>
import { Pie, mixins } from 'vue-chartjs'
export default {
  extends: Pie,
  props: {
    chartData: {
      type: Object,
      default () {
        return {
          labels: ['Nessun voto'],
          data: [0]
        }
      }
    }
  },
  mixins: [mixins.reactiveProp],
  watch: {
    data () {
      this.renderChart(this.data, this.options)
    }
  },
  data () {
    return {
      data: {
        labels: this.chartData.labels,
        datasets: [{
          borderWidth: 1,
          borderColor: [
            'rgba(233, 30, 99,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(23, 226, 205, 1)',
            'rgba(75, 192, 192, 1)'
          ],
          backgroundColor: [
            'rgba(233, 30, 99, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(23, 226, 205, 0.2)',
            'rgba(75, 192, 192, 0.2)'
          ],
          data: this.chartData.data
        }]
      },
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: true
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  }
}
</script>
